<template>
  <div class="server-box">
    <div class="main-body">
      <div class="title-box">专业高效，提升企业效益</div>
      <div class="tab-box clearfix">
        <dl :class="['tab-item', { on: curSolution === 0 }]" @mouseover="changeSolution(0)">
          <dt>成本节省</dt>
          <dd>32%</dd>
        </dl>
        <dl :class="['tab-item', { on: curSolution === 1 }]" @mouseover="changeSolution(1)">
          <dt>货运效率提高</dt>
          <dd>1倍</dd>
        </dl>
        <dl :class="['tab-item', { on: curSolution === 2 }]" @mouseover="changeSolution(2)">
          <dt>减少货运风险</dt>
          <dd>72%</dd>
        </dl>
      </div>
      <ul class="content-box" :style="{ marginLeft: 0 - curSolution * 1200 + 'px' }">
        <li class="content-item">
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_1_1@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>技术成本节省33%</dt>
              <dd>API技术支持</dd>
              <dd>专业用车系统接入</dd>
              <dd>1天快速交接</dd>
            </dl>
          </div>
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_1_2@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>运输成本节省35%</dt>
              <dd>3秒比价，定价透明</dd>
              <dd>实时监控每笔费用明细</dd>
              <dd>比自养车、租车节省35%以上成本</dd>
            </dl>
          </div>
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_1_3@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>人力成本节省28%</dt>
              <dd>当日即开电子普票</dd>
              <dd>月结、充值等支付模式，无需繁琐报销</dd>
            </dl>
          </div>
        </li>
        <li class="content-item">
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_2_1@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>98%匹配率</dt>
              <dd>24+种车型选择</dd>
            </dl>
          </div>
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_2_2@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>95%准点率</dt>
              <dd>三证考核的专业司机</dd>
              <dd>规范操作，路线熟悉</dd>
            </dl>
          </div>
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_2_3@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>100%跟踪</dt>
              <dd>专属客服服务，实时监控路线</dd>
            </dl>
          </div>
        </li>
        <li class="content-item">
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_3_1@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>24小时响应</dt>
              <dd>30万+月活司机，及时用车</dd>
            </dl>
          </div>
          <div class="item-desc">
            <img src="../../assets/img/index/solution/ic_benefit_3_2@2x.png" alt="" />
            <dl class="content-item-desc">
              <dt>100%货物保障</dt>
              <dd>最高200万元货物保额</dd>
            </dl>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curSolution: 0,
    };
  },
  methods: {
    changeSolution(index) {
      this.curSolution = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.server-box {
  width: 100%;
  height: 600px;
  padding-top: 50px;
  margin-top: 50px;
  background: url('../../assets/img/index/bg_main_benefit.jpg') center;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;
  .title-box {
    color: #fff;
  }
  .main-body {
    overflow: hidden;
  }
  .tab-box {
    width: 100%;
    overflow: hidden;
    .tab-item {
      position: relative;
      box-sizing: border-box;
      float: left;
      width: 400px;
      height: 121px;
      padding: 30px 0;
      text-align: center;
      font-size: 18px;
      color: #fff;
      border-bottom: 2px solid #6e6f6f;
      cursor: pointer;
      dd {
        font-size: 32px;
        color: #f16622;
      }
      &.on {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.12) 100%
        );
        border-color: #f16622;
        &:after {
          position: absolute;
          left: 50%;
          bottom: -2px;
          margin-left: -6px;
          content: '';
          width: 0;
          height: 0;
          border-right: 8px solid transparent;
          border-left: 8px solid transparent;
          border-bottom: 8px solid #f16622;
        }
      }
    }
  }
  .content-box {
    overflow: hidden;
    width: 3600px;
    transition: all 0.8s;
    margin-left: 0;
    .content-item {
      float: left;
      width: 1200px;
    }
    .item-desc {
      float: left;
      width: 400px;
      height: 352px;
      text-align: center;
      img {
        width: 164px;
        height: 164px;
        margin-top: 42px;
      }
    }
    .content-item-desc {
      color: #fff;
      font-weight: 400;
      dt {
        font-weight: 500;
        font-size: 18px;
        color: #f16622;
        margin: 10px 0;
      }

      dd {
        line-height: 23px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/solution.vue